import styled from "styled-components";
import { palette } from "styled-theme";
import WithDirection from "@iso/lib/helpers/rtl";

const SignUpStyleWrapper = styled.div`
  width: 100%;
  height: calc(100vh - 70px);
  display: flex;
.userEmail {
  font-weight:900;
}
.error span { color: #E16408}

  .isoSignUpContentWrapper {
    width: 35%;
    @media only screen and (max-width: 767px) {
      width: 100%;
    }
    overflow-y: auto;
    position: relative;
  }

  .isoSignUpContent {
    min-height: 100%;
    display: flex;
    flex-direction: column;
    padding: 50px 50px;
    position: relative;
    background-color: #ffffff;
    h3 {
      margin-bottom: 10px;
    }
    p {
      margin-bottom: 10px;
      
    }
    .logo-signin {
      width:200px;
      margin: auto;
      height: auto;
    }

    @media only screen and (max-width: 767px) {
      width: 100%;
      padding: 70px 20px;
    }

    .isoLogoWrapper {
      width: 100%;
      display: flex;
      margin-bottom: 50px;
      justify-content: center;
      flex-shrink: 0;

      a {
        font-size: 24px;
        font-weight: 300;
        line-height: 1;
        text-transform: uppercase;
        color: ${palette("secondary", 2)};
      }
    }

    .isoSignUpForm {
      width: 100%;
      flex-shrink: 0;
      display: flex;
      flex-direction: column;

      .isoInputWrapper {
        margin-bottom: 25px;

        &:last-child {
          margin-bottom: 0;
        }

        input {
          &::-webkit-input-placeholder {
            color: ${palette("grayscale", 0)};
          }

          &:-moz-placeholder {
            color: ${palette("grayscale", 0)};
          }

          &::-moz-placeholder {
            color: ${palette("grayscale", 0)};
          }
          &:-ms-input-placeholder {
            color: ${palette("grayscale", 0)};
          }
        }
      }

      .isoLeftRightComponent {
        input {
          width: calc(100% - 10px);

          &:first-child {
            margin-right: ${(props) =>
              props["data-rtl"] === "rtl" ? "inherit" : "20px"};
            margin-left: ${(props) =>
              props["data-rtl"] === "rtl" ? "20px" : "inherit"};
          }
        }
      }

      }
    }
  }
`;

export default WithDirection(SignUpStyleWrapper);
